<template>
    <div id="LmTextInputBuilderUi" class="row">
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.value"
        @input="$emit('input', component)"
        label="value"
        placeholder="value"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.type"
        :options="{
          content: [{value: 'submit', text: 'Submit'}, {value: 'button', text: 'Button'}]
        }"
        label="type"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.actions.click.type"
        :options="{
          content: [{value: 'submit', text: 'Submit'}, {value: 'cancel', text: 'Cancel'}]
        }"
        label="Acción"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.path"
        @input="$emit('input', component)"
        label="submit Path"
        placeholder="/mi-endopind-para-procesar"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.pathUpdate"
        @input="$emit('input', component)"
        label="update Path"
        placeholder="/mi-endopind-update"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.class"
        @input="$emit('input', component)"
        label="Clases css"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.buttonClass"
        @input="$emit('input', component)"
        label="buttonClass"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmTextInput,
    LmSelect
  },
  props: {
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-auto',
          componentName: 'LmButton',
          componentProps: {
            type: 'submit',
            value: 'Submit',
            buttonClass: 'btn-primary'
          },
          actions: {
            click: {
              type: 'submit',
              arguments: {
                path: ''
              }
            }
          }
        }
      )
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
